import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyD_EsWfk_mhVubr9VoA8Cvz6hj5QgNYeX0",
    authDomain: "visionary-3d17b.firebaseapp.com",
    projectId: "visionary-3d17b",
    storageBucket: "visionary-3d17b.firebasestorage.app",
    messagingSenderId: "48615733583",
    appId: "1:48615733583:web:135c9b9b6e85382372ed3a",
    measurementId: "G-LE2R26SXSQ"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// remove seo-content
const seo_content = document.querySelector('#seo-content');
if (seo_content) seo_content.remove();

window.oncontextmenu = (e) => e.preventDefault();

// Initialize theme early, before mounting the app
(() => {
  try {
    const saved = localStorage.getItem('theme');
    const systemPrefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    const theme = saved || (systemPrefersDark ? 'dark' : 'light');
    document.documentElement.setAttribute('data-theme', theme);
  } catch (e) {
    // noop: localStorage may be unavailable in some contexts
  }
})();

createApp(App).use(store).use(router).mount('#app')
